<template>
    <div class="home-container" ref="container">
        <div>
            <div class="content" :style="conHeight">
                <div class="contents">
                    <el-row style="height:100%">
                        <el-col :span="8">
                            <div class="cs">
                                <div class="boxleft" @click="childOne=true">
                                    <img class="leftImg" :src="leftBox1"/>
                                    <div class="leftName">
                                        <div class="leftName1">
                                            <span>养老机构数量</span><br>
                                            <count-to :startVal='insCountLast' style="font-size:200%;color:white" separator=''  :endVal='insCount' :duration='2000'></count-to>
                                            <span>家</span>
                                        </div>
                                        <zdy-popess :value='insCount'></zdy-popess>
                                    </div>
                                </div>
                                <div class="boxleft">
                                    <img class="leftImg" :src="leftBox2"/>
                                    <div class="leftName">
                                        <div class="leftName1">
                                            <span>高龄津贴数量</span><br>
                                            <count-to :startVal='oldestCountLast' style="font-size:200%;color:white" separator=''  :endVal='oldestCount' :duration='2000'></count-to>
                                            <span>人</span>
                                        </div>
                                        <zdy-popess :value='oldestCount' :color="['#FF9C81','#FF65A6']"></zdy-popess>
                                    </div>
                                </div>
                                <div class="boxleft">
                                    <img class="leftImg" :src="leftBox3"/>
                                    <div class="leftName">
                                        <div class="leftName1">
                                            <span>社区数量</span><br>
                                            <count-to :startVal='communityCountLast' style="font-size:200%;color:white" separator=''  :endVal='communityCount' :duration='2000'></count-to>
                                            <span>个</span>
                                        </div>
                                        <!-- <div class="popess">
                                            <div style="width:75%">
                                                <div class="popess1" style="background-image: linear-gradient(to right, #2F62FC , #A737FD);"></div>
                                            </div>
                                        </div> -->
                                        <zdy-popess :value='communityCount' :color="['#2F62FC','#A737FD']"></zdy-popess>
                                    </div>
                                </div>
                                <div class="boxleft">
                                    <img class="leftImg" :src="leftBox4"/>
                                    <div class="leftName">
                                        <div class="leftName1">
                                            <span>志愿者数量</span><br>
                                            <count-to :startVal='volunteerCountLast' style="font-size:200%;color:white" separator=''  :endVal='volunteerCount' :duration='2000'></count-to>
                                            <span>人</span>
                                        </div>
                                        <!-- <div class="popess">
                                            <div style="width:95%">
                                                <div class="popess1" style="background-image: linear-gradient(to right, #2DFB99 , #00A294);"></div>
                                            </div>
                                        </div> -->
                                        <zdy-popess :value='volunteerCount' :color="['#2DFB99','#2DFB99']"></zdy-popess>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div id="myCharts"></div>
                        </el-col>
                        <el-col :span="8" style="padding-left:2.6vw">
                            <el-col :span="item[0]" v-for="(item,i) in routerValue" :key="i" >
                                <div class="boxright" @click="openPage(item[2])">
                                    <img class="rightImg" :src="rightRouter"/>
                                    <div class="rightName">
                                        <span>{{item[1]}}</span>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="orderNum" style="min-height: 300px;">
                                    <el-col :span="24" style="display: flex;justify-content: center;">
                                        <div class="orderNumName">
                                            <img class="orderNumImg" :src="orderNumName"/>
                                            <div class="numName">
                                                <span>订单数量</span>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" style="padding:7px">
                                        <div class="orderNum orderType">
                                            <img class="orderImg" :src="xiadan"/>
                                            <div class="orderInfo" >
                                                <span>下单量</span><br>
                                                <count-to :startVal='buildLast>100000?buildLast/10000:buildLast' style="font-size: 1.6vw;color:white" separator=''  :decimals='build>100000?2:0' :endVal='build>100000?build/10000:build' :duration='2000'></count-to>
                                                <span v-show="build>100000">万单</span>
                                                <span v-show="build<=100000">单</span>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" style="padding:7px">
                                        <div class="orderNum orderType">
                                            <img class="orderImg" :src="jiedan"/>
                                            <div class="orderInfo">
                                                <span>接单量</span><br>
                                                <count-to :startVal='acceptLast>100000?acceptLast/10000:acceptLast' style="font-size: 1.6vw;color:white" separator=''  :decimals='accept>100000?2:0' :endVal='accept>100000?accept/10000:accept' :duration='2000'></count-to>
                                                <span v-show="accept>100000">万单</span>
                                                <span v-show="accept<=100000">单</span>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" style="padding:7px">
                                        <div class="orderNum orderType" >
                                            <img class="orderImg" :src="zhengzai"/>
                                            <div class="orderInfo">
                                                <span>正在服务工单量</span><br>
                                                <count-to :startVal='serveLast>100000?serveLast/10000:serveLast' style="font-size: 1.6vw;color:white" separator='' :decimals='serve>100000?2:0'  :endVal='serve>100000?serve/10000:serve' :duration='2000'></count-to>
                                                <span v-show="serve>100000">万单</span>
                                                <span v-show="serve<=100000">单</span>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" style="padding:7px">
                                        <div class="orderNum orderType" >
                                            <img class="orderImg" :src="wancheng"/>
                                            <div class="orderInfo">
                                                <span>已完成工单量</span><br>
                                                <count-to :startVal='successLast>100000?successLast/10000:successLast' style="font-size: 1.6vw;color:white" separator='' :decimals='success>100000?2:0' :endVal='success>100000?success/10000:success' :duration='2000'></count-to>
                                                <span v-show="success>100000">万单</span>
                                                <span v-show="success<=100000">单</span>
                                            </div>
                                        </div>
                                    </el-col>
                                </div>
                            </el-col>
                        </el-col>
                        <el-col :span="24" style="padding-top:1vh">
                            <el-col :span="8" style="padding-right:30px">
                                <div class="orderNum orderType" style="height:18.2vh;min-height: 134px;">
                                    <el-col :span="12" style="padding-left:30px">
                                        <img class="orderImg" :src="shilao" style="height:81px;width:70px"/>
                                        <div class="orderInfo" style="margin-top:10px">
                                            <span>适老化改造</span><br>
                                            <count-to :startVal='optimalAgingCountLast' style="font-size:32px;color:white" separator=''  :endVal='optimalAgingCount' :duration='2000'></count-to>
                                            <span>家</span>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" style="padding-left:30px">
                                        <img class="orderImg" :src="zhihui" style="height:81px;width:70px"/>
                                        <div class="orderInfo" style="margin-top:10px">
                                            <span>智慧化改造</span><br>
                                            <count-to :startVal='wisdomCountLast' style="font-size:32px;color:white" separator=''  :endVal='wisdomCount' :duration='2000'></count-to>
                                            <span>家</span>
                                        </div>
                                    </el-col>
                                </div>
                            </el-col>
                            <el-col :span="8" style="padding:0 15px">
                                <div class="orderNum orderType" style="height:18.2vh;min-height: 134px;">
                                    <el-col :span="12" style="padding-left:30px">
                                        <img class="orderImg" :src="fuwus" style="height:81px;width:70px"/>
                                        <div class="orderInfo" style="margin-top:10px">
                                            <span>服务商数量</span><br>
                                            <count-to :startVal='businessLast' style="font-size:32px;color:white" separator=''  :endVal='business' :duration='2000'></count-to>
                                            <span>家</span>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" style="padding-left:30px">
                                        <img class="orderImg" :src="fuwuren" style="height:81px;width:70px"/>
                                        <div class="orderInfo" style="margin-top:10px">
                                            <span>服务人员数量</span><br>
                                            <count-to :startVal='servicePeopleLast' style="font-size:32px;color:white" separator=''  :endVal='servicePeople' :duration='2000'></count-to>
                                            <span>人</span>
                                        </div>
                                    </el-col>
                                </div>
                            </el-col>
                            <el-col :span="8" style="padding-left:30px">
                                <div class="orderNum orderType" style="height:18.2vh;min-height: 134px;">
                                    <img class="orderImg" :src="shengshi"/>
                                    <div style="width:80%">
                                        <div class="csNum"><span>服务城市数量</span><span style="font-size:18px;color:rgba(35, 242, 255, 1)">（座）</span></div>
                                        <!-- <div class="popess" style="display:inline-block;width:70%">
                                            <div style="width:60%">
                                                <div class="popess1" style="background-image: linear-gradient(to right, #0BBBE7 , #2758F8);"></div>
                                            </div>
                                        </div> -->
                                        <zdy-popess :value='government' style="display:inline-block;width:70%" :color="['#0BBBE7','#2758F8']"></zdy-popess>
                                        <count-to :startVal='governmentLast' style="font-size:32px;color:white" separator=''  :endVal='government' :duration='2000'></count-to>
                                    </div>

                                </div>
                            </el-col>
                        </el-col>
                    </el-row>

                </div>
            </div>
        </div>
        <Siren></Siren>
        <el-dialog  :fullscreen='true' :visible.sync="childOne" :modal='false' @opened='openedChild' @colse='closeChild'>
            <Map ref="indexMap"></Map>
        </el-dialog>
    </div>
</template>

<script>
    // import 'echarts-liquidfill'
    import countTo from 'vue-count-to'
    import Siren from '../Siren'
    import Map from './map'
    import zdyPopess from "@/components/Popess.vue";
    import {timefilters} from "@/common/times";
    import leftBox1 from "./img/leftBox1.png"
    import rightRouter from "./img/rightRouter.png"
    import orderNumName from "./img/orderNumName.png"
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import { getToken,getInsNameByDomainName } from '@/utils/auth'
    export default {
        name: "Home",
        data(){
            return{
              // suibian: "scale(1,1)",
                childOne:false,
                routerValue:[
                    [6,'居家养老','/HomeCare'],
                    [6,'机构养老','/Institution'],
                    [6,'社区养老','/CommunityRetirement'],
                    [6,'志愿者','/Volunteer'],
                    [6,'高龄津贴','/OldAgeAllo'],
                    [6,'服务对象','/ServiceObject'],
                    [6,'智能设备','/IntelligentDevice'],
                    [6,'定位','/Location'],
                    [6,'适老化改造','http://reformadm.ltylao.com'],
                    [7,'家庭养老床位','/OldAgeBed'],
                    // [6,'智慧消防','zhihuixiaofang'],
                    [6,'智慧消防','/Device/Connector'],
                    [5,'监控','/Monitoring/Index']
                ],
                time:timefilters(new Date()),
                topTitle:require('./img/topTitle.png'),
                topTime:require('./img/time.png'),
                leftBox2:require('./img/leftBox2.png'),
                leftBox3:require('./img/leftBox3.png'),
                leftBox4:require('./img/leftBox4.png'),
                xiadan:require('./img/xiadan.png'),
                jiedan:require('./img/jiedan.png'),
                zhengzai:require('./img/zhengzai.png'),
                wancheng:require('./img/wancheng.png'),
                shilao:require('./img/shilao.png'),
                zhihui:require('./img/zhihui.png'),
                fuwus:require('./img/fuwus.png'),
                fuwuren:require('./img/fuwuren.png'),
                shengshi:require('./img/shengshi.png'),
                leftBox1:leftBox1,
                rightRouter:rightRouter,
                orderNumName:orderNumName,
                myCharts:'',
                insCount:0,
                oldestCount:0,
                communityCount:0,
                volunteerCount:2869,
                government:31,
                optimalAgingCount:78,
                wisdomCount:145,
                business:0,
                nextPersonNum9:0,
                servicePeople:0,
                build:0,
                accept:0,
                serve:0,
                success:0,
                businessLast:0,
                servicePeopleLast:0,
                buildLast:0,
                acceptLast:0,
                serveLast:0,
                successLast:0,
                lastPersonNum:0,
                governmentLast:0,
                oldestCountLast:0,
                volunteerCountLast:0,
                communityCountLast:0,
                optimalAgingCountLast:0,
                insCountLast:0,
                wisdomCountLast:0,
                serviceObject:0,
                conHeight:{
                    height:''
                }
            }
        },
        mounted(){
            this.$nextTick(()=>{ // 页面渲染完成后的回调
                this.conHeight.height=this.$refs.container.offsetHeight-95+'px'
            })
            this.init()
            var that=this
            window.addEventListener("resize", () => {
                that.myCharts.resize();
            });
        },
        components:{countTo,zdyPopess,Siren,Map},
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(){
                this.conHeight.height=this.$refs.container.offsetHeight-95+'px'
            },
        },
        created(){
          // this.getHomeData();
          /*window.addEventListener("resize",()=>{
            var height = window.innerHeight;
            var width = window.innerWidth;
            console.log("height: ",height);
            console.log("width: ",width);

            this.suibian = "scale(" + width/1920 + "," + height/937 +")";
          });*/
          console.log("当前登录信息为： ",JSON.parse(getToken()));
        },
        methods:{
            init(){
                var that=this
                setInterval(function () {
                    that.time=timefilters(new Date());
                }, 1000);
                this.myCharts = this.$echarts.init(document.getElementById('myCharts'))
                this.getGauge()
                this.$store.commit('update', ['title',getInsNameByDomainName()+'智慧云']);
                this.getHomeData();

                // 获取养老机构数量：
                this.getInstitutionCount();
                // 获取高龄津贴数量
                this.getGaolingJinTieCount();
                // 获取社区数量
                this.getSheQuCount();
                // 获取订单数量
                this.getOrderData();
            },
            getFuWuDataBySheHuiHua(){
            var token = JSON.parse(getToken());
            this.$axios({
              method: 'post',
              url: this.$shopUrl + "/Views/getFuWuDataBySheHuiHua",
              data: {
                timeStr:timeStr,
                sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                governmentCodeList:token.visualAccountShopGovernmentCodeList,
              }
            }).then( (response)=> {
              if(response.data.error == 0){
                var res = response.data.data;
                this.business += this.business + res.fuwushang;
                this.servicePeople += res.fuwurenyuan;
                this.build += res.xiadanliang;
                this.accept += res.jiedanlaing;
                this.serve += res.serviceDanLiang;
                this.success += res.wanchengDanLiang;
              }else if(response.data.error == 1) {
                this.$message({type: 'info', message: response.data.message});
              }
            })
          },
            getInstitutionCount(){
              this.$axios({
                method: 'post',
                url: this.$institutionUrl+"Visual/GetListLonNotNull",
                data: {
                  timeStr:timeStr,
                  sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  governmentCodeList:JSON.parse(getToken()).visualAccountInsGovernmentCodeList
                }
              }).then( (response)=> {
                if(response.data.error == 0){
                    this.insCount = response.data.data.length;
                }else if(response.data.error == 1) {
                  this.$message({type: 'info', message: response.data.message});
                }
              })
            },
            getGaolingJinTieCount(){
              var token = JSON.parse(getToken());
              this.$axios({
                method: 'post',
                url: this.$visualizationUrl + "/Views/GetGaolingJinTieCount",
                data: {
                  timeStr:timeStr,
                  sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  governmentCodeList:token.visualAccountHomeGovernmentCodeList
                }
              }).then( (response)=> {
                if(response.data.error == 0){
                  this.oldestCount = response.data.data;
                }else if(response.data.error == 1) {
                  this.$message({type: 'info', message: response.data.message});
                }
              })
            },
            getSheQuCount(){
              this.$axios({
                method: 'post',
                url: this.$communityUrl + "/Community/getSheQuCount",
                data: {
                  timeStr:timeStr,
                  sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                }
              }).then( (response)=> {
                if(response.data.error == 0){
                  this.communityCount = response.data.data;
                }else if(response.data.error == 1) {
                  this.$message({type: 'info', message: response.data.message});
                }
              })
            },
            getOrderData(){
              var token = JSON.parse(getToken());
              this.$axios({
                method: 'post',
                url: this.$visualizationUrl + "/Views/getOrderData",
                data: {
                  timeStr:timeStr,
                  sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  governmentCodeList:token.visualAccountHomeGovernmentCodeList
                }
              }).then( (response)=> {
                if(response.data.error == 0){
                  var res = response.data.data;
                  this.business = this.business + res.fuwushang;
                  this.servicePeople = res.fuwurenyuan;
                  this.build = res.xiadanliang;
                  this.accept = res.jiedanlaing;
                  this.serve = res.serviceDanLiang;
                  this.success = res.wanchengDanLiang;
                  // 从社会话中获取服务商和服务人员数量：
                  this.getFuWuDataBySheHuiHua();
                }else if(response.data.error == 1) {
                  this.$message({type: 'info', message: response.data.message});
                }
              })
            },


            openedChild(){
                this.$refs.indexMap.init(this.dataInfo)
            },
            closeChild(){
              this.$refs.indexMap.myChart.clear();
            },
            getHomeData(){
                // var that=this
                this.$axios({
                    method: 'post',
                    url: this.$visualizationUrl+"Views/HomeDataNew",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        visualAccountCode:JSON.parse(getToken()).visualAccount.visualAccountCode
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        var resolve=response.data.data;
                        this.businessLast=this.business
                        this.servicePeopleLast=this.servicePeople
                        this.buildLast=this.build
                        this.acceptLast=this.accept
                        this.serveLast=this.serve
                        this.successLast=this.success
                        this.governmentLast=this.government
                        this.oldestCountLast=this.oldestCount
                        this.communityCountLast=this.communityCount
                        this.volunteerCountLast=this.volunteerCount
                        this.optimalAgingCountLast=this.optimalAgingCount
                        this.wisdomCountLast=this.wisdomCount
                        this.insCountLast=this.insCount

                        this.business+=resolve.business
                        this.servicePeople+=resolve.servicePeople
                        this.build+=resolve.build
                        this.accept+=resolve.accept
                        this.serve+=resolve.serve
                        this.success+=resolve.success
                        this.government+=resolve.government
                        this.oldestCount+=resolve.oldestCount
                        this.communityCount+=resolve.communityCount
                        this.volunteerCount+=resolve.volunteerCount
                        this.optimalAgingCount+=resolve.optimalAgingCount
                        this.wisdomCount+=resolve.wisdomCount
                        this.insCount+=resolve.insCount
                        if(JSON.parse(getToken()).visualAccount.visualAccountCode=='d2e824d0-38d5-4f54-b7f4-ba22cb6502d8'){
                            this.insCount=1
                            this.oldestCount=159
                            this.communityCount=1
                            this.volunteerCount=500
                            this.optimalAgingCount=15
                            this.wisdomCount=2
                            this.business=5
                            this.servicePeople=9
                            this.government=1
                            this.build=81
                            this.accept=81
                            this.success=81
                        }
                        if(resolve.serviceObject!=this.serviceObject){
                            this.serviceObject+=resolve.serviceObject
                            this.getGauge()
                        }
                        // setTimeout(function(){that.getHomeData()}, 30000)
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                })
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Views/HomeData",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        governmentCodeList:JSON.parse(getToken()).visualAccountShopGovernmentCodeList
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        var resolve=response.data.data;
                        this.businessLast=this.business
                        this.servicePeopleLast=this.servicePeople
                        this.buildLast=this.build
                        this.acceptLast=this.accept
                        this.serveLast=this.serve
                        this.successLast=this.success
                        this.governmentLast=this.government
                        this.business+=resolve.business
                        this.servicePeople+=resolve.servicePeople
                        this.build+=resolve.build
                        this.accept+=resolve.accept
                        this.serve+=resolve.serve
                        this.success+=resolve.success
                        this.government+=resolve.government
                        if(JSON.parse(getToken()).visualAccount.visualAccountCode=='d2e824d0-38d5-4f54-b7f4-ba22cb6502d8'){
                            this.business=5
                            this.servicePeople=9
                            this.government=1
                            this.build=81
                            this.accept=81
                            this.success=81
                        }
                        if(resolve.serviceObject>0){
                            this.serviceObject+=resolve.serviceObject
                            this.getGauge()
                        }
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                })
            },
            getAxios(url){
                return new Promise((resolve, reject) => {
                    this.$axios({
                        method: 'post',
                        url: this.$visualizationUrl+url,
                        data: {
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        }
                    }).then( (response)=> {
                        if(response.data.error == 0){
                            resolve(response.data.data);
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }).catch(function (error) {
                        reject(error.data)
                    });
                });
            },
            openPage(url){
                if(url=='zhihuixiaofang'){
                    this.$alert('正在与清华公共安全研究院（辰安天泽）智慧消防系统对接中！', '提示', {
                        confirmButtonText: '确定',
                    });
                    return;
                }
                var str=url.slice(0,4);
                if(str=='http'){
                    window.open(url, '_blank');
                    return;
                }
                let routeData = this.$router.resolve({
                     path: url
                });
                window.open(routeData.href, '_blank');
            },
            getGauge(){
                var that=this
                var num=that.serviceObject>100000?(that.serviceObject/10000).toFixed(2):that.serviceObject
                var iswan=that.serviceObject>100000?true:false
                var length=that.serviceObject.toString().length
                var numStr=Math.pow(10,length)

                var colorSet = {
                    color: '#00FAFF'
                };
                var option = {
                    backgroundColor: "transparent",
                    title: {
                        show: true,
                        text: iswan?'服务对象总人数(万)':'服务对象总人数',
                        x: '49%',
                        y: '80%',
                        z: 8,
                        textAlign: 'center',
                        textStyle: {
                            color: ' #DFFFFF ',
                            fontSize: 26,
                        },

                    },
                    series: [
                        {
                            name: "内部进度条",
                            type: "gauge",
                            radius: '63%',
                            splitNumber: 10,
                            axisLine: {
                                lineStyle: {
                                    color: [
                                        [that.serviceObject / numStr, new this.$echarts.graphic.LinearGradient(
                                                0, 0, 1, 0, [{
                                                        offset: 0,
                                                        color: '#0099FF',
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: '#00FAFF',
                                                    }
                                                ]
                                            )
                                        ],
                                        [1, "transparent"]
                                    ],
                                    width: 14
                                }
                            },
                            axisLabel: {
                                show: false,
                            },
                            axisTick: {
                                show: false,

                            },
                            splitLine: {
                                show: false,
                            },


                            pointer: {
                                show: false,
                            },
                        },
                        {
                            name: '外部刻度',
                            type: 'gauge',
                            radius: '80%',
                            min: 0, //最小刻度
                            max: 100, //最大刻度
                            splitNumber: 10, //刻度数量
                            startAngle: 225,
                            endAngle: -45,
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    width: 2,
                                    color: [
                                        [1, 'rgba(0,0,0,0)']
                                    ]
                                }
                            },
                            //仪表盘轴线
                            axisLabel: {
                                show: true,
                                color: '#FFFFFF',
                                distance: 25,
                                formatter: function (v) {
                                    return iswan?numStr*v/1000000+'W':numStr*v/100;
                                }
                            }, //刻度标签。
                            axisTick: {
                                show: true,
                                splitNumber: 7,
                                lineStyle: {
                                    color: colorSet.color, //用颜色渐变函数不起作用
                                    width: 2,
                                },
                                length: -8
                            }, //刻度样式
                            splitLine: {
                                show: true,
                                length: -20,
                                lineStyle: {
                                    color: colorSet.color, //用颜色渐变函数不起作用
                                }
                            }, //分隔线样式
                            detail: {
                                show: false
                            },
                            pointer: {
                                show: false
                            }
                        },
                        /*内部*/
                        {
                            type: 'pie',
                            radius: ['0', '35%'],
                            center: ['50%', '50%'],
                            z: 8,
                            hoverAnimation: false,
                            data: [{
                                name: '污染程度',
                                value: num,
                                itemStyle: {
                                    normal: {
                                        color: new  this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: '#4FADFD'
                                        }, {
                                            offset: 1,
                                            color: '#28E8FA'
                                        }])
                                    }

                                },
                                label: {
                                    normal: {
                                        rich: {
                                            a: {
                                                color: '#468EFD',
                                                align: 'center',
                                                fontSize: 50,
                                                fontWeight: "bold"
                                            },
                                        },
                                        formatter: function (params) {
                                            return "{a|" + params.value + "}";
                                        },
                                        position: 'center',
                                        show: true
                                    }
                                },
                                labelLine: {
                                    show: false
                                }
                            }],
                        },
                        /*外一层*/
                        {
                            type: "pie",
                            radius: "40%",
                            startAngle: 220,
                            endAngle: -40,
                            hoverAnimation: false,
                            center: ["50%", "50%"],
                            avoidLabelOverlap: false,
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            data: [{
                                value: 1
                            }],
                            itemStyle: {
                                normal: {
                                    color: {
                                        type: "linear",
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0,
                                            color: "rgba(69, 161, 255,0.8)"
                                        }, {
                                            offset: 1,
                                            color: "rgba(69, 161, 255,0.5)"
                                        }]
                                    }
                                }
                            }
                        },
                        //外二层圈
                        {
                            type: "pie",
                            radius: "45%",
                            center: ["50%", "50%"],
                            avoidLabelOverlap: false,
                            z: 0,
                            hoverAnimation: false,
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            data: [{
                                "value": 1
                            }],
                            itemStyle: {
                                normal: {
                                    color: {
                                        type: "linear",
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0,
                                            color: "rgba(69, 161, 255,0.5)"
                                        }, {
                                            offset: 1,
                                            color: "rgba(69, 161, 255,0.3)"
                                        }]
                                    }
                                }
                            }
                        },
                        //最外层圈
                        {
                            type: "pie",
                            radius: "50%",
                            center: ["50%", "50%"],
                            avoidLabelOverlap: false,
                            z: 0,
                            hoverAnimation: false,
                            label: {
                                show: false,
                            },
                            labelLine: {
                                show: false
                            },
                            data: [{
                                value: 1
                            }],
                            itemStyle: {
                                normal: {
                                    color: {
                                        type: "linear",
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0,
                                            color: "rgba(69, 161, 255,0.3)"
                                        },
                                            {
                                                offset: 1,
                                                color: "rgba(69, 161, 255,0)"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        //最外层圈
                        {
                            type: "pie",
                            radius: "100%",
                            center: ["50%", "50%"],
                            avoidLabelOverlap: false,
                            z: -1,
                            hoverAnimation: false,
                            label: {
                                show: false,
                            },
                            labelLine: {
                                show: false
                            },
                            data: [{
                                value: 1
                            }],
                            itemStyle: {
                                normal: {
                                    color:'#132F81',
                                    shadowColor: 'rgba(10, 83, 177, 1)',
                                    shadowBlur:37
                                }
                            }
                        }
                    ],
                };
                this.myCharts.setOption(option)

            }
        }

    }


</script>

<style lang="scss"  scoped>
/*$duration:0.2s;
@mixin transition($props) {
  $transition: (); //声明空变量
  @for $i from 1 through length($props) { //循环$props
    $transition: append( //每次附加
        $transition,
          (nth($prop, $i) $duration), //nth是取变量
      $separator: comma //设置分隔符为逗号，不写默认为空格
    );
  }
  transition: $transition;
}*/
//css output:
//transition: height 0.2s, width 0.2s, transform 0.2s;



    .home-container {
      //scss input:
      //@include transition(1000 750 transform);
      //transform:  scale(0,0);
        width: 100%;
        height:100vh;
        //height: 937px;
        //width: 1920px;
        margin-top: -75px;
        background-image: url(./img/background.jpg);
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center top;
        min-width: 1360px;
        min-height: 736px;
        .content{
            height: 100%;
            margin: 0;
            padding: 0;
            // margin-top: 80px;
            padding:0 2.6vw;
            padding-top: 90px;
        }
        .contents{
            min-width: 1220px;
            #myCharts{
                border-radius: 50%;
                height:64vh;
                width:100%;
                min-height: 471px;
            }
            .cs{
                padding: 10px 0;
            }
            .boxright{
                width: 100%;
                height: 6vh;
                min-height: 40px;
                position: relative;
                margin-bottom: 1.7vh;
                cursor: pointer;
                .rightImg{
                    height: 100%;
                    width: 100%;
                    position: absolute;
                }
                .rightName{
                    position: relative;
                    color: #fff;
                    font-size: 20px;
                    display: flex;
                    height: 100%;
                    align-items: center;
                    justify-content: center;
                }

            }
            .orderNum{
                width: 100%;
                height: 39.4vh;

                border: 1px solid rgba(8, 188, 255, 0.5);
                box-sizing: border-box;
                box-shadow: inset 5px 5px 30px 5px rgba(3, 34, 90, 1);
                background:rgba(8,21,66,0.5);
                border-radius:10px;
                padding: 0 15px;
                .orderNumName{
                    width: 230px;
                    height: 60px;
                    position: relative;
                    .orderNumImg{
                        height: 100%;
                        width: 100%;
                        position: absolute;
                    }
                    .numName{
                        position: relative;
                        color: #fff;
                        font-size: 22px;
                        display: flex;
                        height: 100%;
                        align-items: center;
                        justify-content: center;
                    }
                }

            }
            .orderType{
                height:13.7vh;
                min-height: 100px;
                display: flex;
                align-items: center;
                // justify-content: center;
                .orderImg{
                    height: 64px;
                    width: 64px;
                    float: left;
                    margin-right:10px
                }
                .orderInfo{
                    color: rgba(35, 242, 255, 1);
                }
            }
            .bottom{
                height:18.2vh;
                display:flex;
                align-items: center;
            }
            .boxleft{
                width: 100%;
                position: relative;
                height: 12vh;
                min-height: 88px;
                margin: 2.28vh 0;
                .leftImg{
                    height: 100%;
                    width: 100%;
                    position: absolute;
                }
                .leftName{
                    position: relative;
                    color: #23F2FF;
                    // font-size: 18px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    .leftName1{
                        width: 120px;
                        margin-left:8%;
                        font-size: 100%;
                    }

                }
            }
            .popess{
                width: 45%;
                background: #323F62;
                border-radius: 15px;
                height: 15px;
                margin-left: 3%;
                overflow: hidden;
            }
            .popess1{
                background-image: linear-gradient(to right, #4635F3 , #4BF6EE);
                border-radius: 15px;
                height: 15px;
                animation:mymove 2s normal forwards ease-in-out;
            }
            @keyframes mymove{
                from {width: 0%;}
                to {width: 100%;}
            }
            .csNum{
                color: white;
                font-size: 24px;
                margin-left: 3%;
            }
        }
        /deep/ .el-dialog{
            background: transparent;
        }
        /deep/ .el-dialog__body {
            padding:0;
        }
        /deep/ .el-dialog__header{
            padding: 0;
        }
        /deep/ .el-dialog__headerbtn{
            z-index: 1;
            font-size: 30px;
            right: 16px;
        }
        /deep/ .el-dialog__headerbtn .el-dialog__close{
            color: rgba(28, 226, 255, 1);
            border: 1px solid #1ce2ff;
            border-radius: 5px;
            padding: 2px 2px 6px 6px;
            border-bottom-left-radius: 50px;
            border-bottom-left-radius: 5px;
            border-bottom-left-radius: 40px;
            z-index: 20;
        }
    }

</style>
